import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import CustomerWalletHistoryDialog from '../../components/pos/CustomerWalletHistoryDialog';

export default function DashboardCustomerDetailDialog({
  open,
  selectedCustomer,
  isCustomerDetailLoading,
  customerDetail,
  formatCustomerAddress,
  onClose,
  onChange,
  onRemove,
}) {
  const [walletOpen, setWalletOpen] = useState(false);
  const walletCustomer = customerDetail?.id ? customerDetail : selectedCustomer;
  const pointsBalance = customerDetail?.loyalty?.enrolled ? customerDetail.loyalty.points_balance : null;

  return (
    <>
    <Dialog
      open={open && !!selectedCustomer}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '12px' } }}
    >
      <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography fontSize="1rem" fontWeight={800} color="#1E293B">
          Customer Details
        </Typography>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            color: '#94A3B8',
            borderRadius: '8px',
            transition: 'all 0.15s ease',
            '&:hover': {
              color: '#64748B',
              bgcolor: '#F1F5F9',
            },
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        {isCustomerDetailLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress size={22} />
          </Box>
        ) : (
          <Stack spacing={1.1}>
            <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>Name</Typography>
            <Typography fontSize="0.9rem" color="#1E293B" fontWeight={700}>
              {customerDetail?.name || selectedCustomer?.name || '—'}
            </Typography>
            <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>Phone</Typography>
            <Typography fontSize="0.84rem" color="#334155">
              {customerDetail?.phone_number || selectedCustomer?.phone_number || '—'}
            </Typography>
            <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>Email</Typography>
            <Typography fontSize="0.84rem" color="#334155" sx={{ wordBreak: 'break-word' }}>
              {customerDetail?.email || '—'}
            </Typography>
            <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>GSTIN</Typography>
            <Typography fontSize="0.84rem" color="#334155" sx={{ wordBreak: 'break-word' }}>
              {customerDetail?.gstin || '—'}
            </Typography>
            <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>Address</Typography>
            <Typography fontSize="0.84rem" color="#334155" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {formatCustomerAddress(customerDetail?.address)}
            </Typography>
            <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>Wallet Balance</Typography>
            <Typography fontSize="0.88rem" color="#16A34A" fontWeight={800}>
              ₹{parseFloat(customerDetail?.credit_balance || 0).toFixed(2)}
            </Typography>
            {pointsBalance != null && (
              <>
                <Typography fontSize="0.76rem" color="#94A3B8" fontWeight={700}>Loyalty Points</Typography>
                <Typography fontSize="0.88rem" color="#1E293B" fontWeight={800}>
                  {parseFloat(pointsBalance || 0).toFixed(2)} pts
                </Typography>
              </>
            )}
            <Box>
              <Button size="small" onClick={() => setWalletOpen(true)} disabled={!walletCustomer?.id}
                sx={{ textTransform: 'none', fontWeight: 700, color: '#4F46E5', px: 0, minWidth: 0 }}>
                View wallet history →
              </Button>
            </Box>
          </Stack>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2, gap: 1 }}>
        <Button
          onClick={onChange}
          variant="outlined"
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            borderColor: '#C7D2FE',
            color: '#4F46E5',
            transition: 'all 0.15s ease',
            '&:hover': {
              borderColor: '#A5B4FC',
              bgcolor: '#EEF2FF',
              color: '#4338CA',
            },
          }}
        >
          Change
        </Button>
        <Button
          onClick={onRemove}
          variant="contained"
          disableElevation
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            bgcolor: '#EF4444',
            transition: 'all 0.15s ease',
            '&:hover': {
              bgcolor: '#DC2626',
              boxShadow: '0 6px 14px rgba(220,38,38,0.25)',
            },
          }}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
    <CustomerWalletHistoryDialog
      open={walletOpen}
      customer={walletCustomer}
      showPoints={!!customerDetail?.loyalty?.enabled}
      onClose={() => setWalletOpen(false)}
    />
    </>
  );
}
